import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_398: DocMigration = {
  maxSchemaVersion: "0.0.398",
  description: "Remove unused properties from propInstances",
  apply(json: any) {
    if (!json.viewTemplates) {
      return json;
    }

    for (const id in json.viewTemplates) {
      const viewTemplate = json.viewTemplates[id];
      const newCategories: string[] = [];

      for (const category of viewTemplate.categories) {
        if (!categoryIsGenerator[category]) {
          newCategories.push(category);
        }
      }

      viewTemplate.categories = newCategories;
    }

    return json;
  },
};

export default migration_0_0_398;

const categoryIsGenerator: { [key: string]: boolean } = {
  FOUNDATION_LINEWORK: true,
  ANNOT_DIM: true,
  ALL_LVL_ANNOT_DIM: true,
  FOUNDATION_DIMENSIONS: true,
  UTILITY_DIMENSIONS: true,
  WALL_INTERIOR_DIMENSIONS: true,
  WALL_EXTERIOR_DIMENSIONS: true,
};
